<template>
  <GChart
    :settings="{ packages: ['corechart', 'treemap'] }"
    type="TreeMap"
    :data="treemapChartdata"
    :options="options"
  />
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  components: { GChart },
  props: ["chartdata"],
  data() {
    return {
      options: {
        minColor: '#f00',
        midColor: '#ddd',
        maxColor: '#0d0',
        headerHeight: 0,
        fontColor: 'black',
        height: 500
      }
    }
  },
  computed: {
    treemapChartdata() {
      let data = [
        ['Location', 'Parent', 'Value for size', 'Value for color'],
        ['Root', null, 0, 0],
      ]
      this.chartdata.forEach((d) => {
        data.push([d[0], "Root", d[1], d[1]])
      })

      return data
    }
  }
}
</script>

<style>

</style>
